var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url,"frameborder":"2","allow":"accelerometer;\n  autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }